module.exports = __webpack_public_path__ + "img/4.613f8a50.jpg";